import axios from "axios";

import { initCommonSettings } from "@krea/customer-features/settings";

const getKreaBaseUrl = () => {
  let url = "http://localhost:8000";

  if (import.meta.env.REACT_APP_APPLICATION_ENV === "production") {
    url = "https://customer-api.krea.se";
  } else if (import.meta.env.REACT_APP_APPLICATION_ENV === "staging") {
    url = "https://staging.krea.se";
  } else if (import.meta.env.REACT_APP_APPLICATION_ENV === "test") {
    url = "https://test.krea.se";
  } else if (import.meta.env.REACT_APP_APPLICATION_ENV === "local-docker") {
    url = "http://localhost:8000";
  }

  return url;
};

const settings = initCommonSettings({
  environment: import.meta.env.REACT_APP_APPLICATION_ENV || "local",
  backendBaseUrl: import.meta.env.API_ROOT_URL,
  unauthorizedPaths: ["/login", "/register"],
});

// Set global axios config
axios.defaults.baseURL = settings.backendBaseUrl;

// TODO: Set up separate customerAxios that does cookie-auth
axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

// eslint-disable-next-line import/no-default-export
export default settings;
